import Call from '../Call.v2';
import {objToQs} from '../Utils';

const AdkBoosters = {
    get(filters) {
        return Call(`adk/boosters?${objToQs(filters)}`, );
    },

    save(booster) {
        return Call('adk/boosters','POST', booster);
    },

    update(id, booster) {
        return Call(`adk/boosters/${id}`,'PUT', booster);
    },

    remove(id) {
        return Call(`adk/boosters/${id}`,'DELETE');
    }
};

export default AdkBoosters;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkBoosters.js